// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:769px){.break-out-up[data-v-a4d5656a]{margin-top:-3rem}}.related-results[data-v-a4d5656a]{flex:1;overflow:auto;padding:1rem}@media screen and (max-width:768px){.related-results .column[data-v-a4d5656a]{min-width:8em}}.no-data[data-v-a4d5656a]{display:flex;align-items:center;justify-content:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
